import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type ShowPriceIndexConnectTooltipResp as SchemaShowPriceIndexConnectTooltipResp } from '../schemas/ShowPriceIndexConnectTooltipResp';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Products
 */
export const ShowPriceIndexConnectTooltipContentType = '' as const;
export type ShowPriceIndexConnectTooltipRequest = void;
export type ShowPriceIndexConnectTooltipResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of data
     */
    '200': {
        'application/json': SchemaShowPriceIndexConnectTooltipResp;
    };
};
export type ShowPriceIndexConnectTooltipResponseSuccess =
    ShowPriceIndexConnectTooltipResponses['200']['application/json'];
export type ShowPriceIndexConnectTooltipSearchParams = undefined;
export type ShowPriceIndexConnectTooltipPathParameters = undefined;
export const ShowPriceIndexConnectTooltipUrl = '/price-index/show-tooltip' as const;
export const ShowPriceIndexConnectTooltipMethod = 'GET' as const;
export const getShowPriceIndexConnectTooltipUrl = (_params?: ShowPriceIndexConnectTooltipPathParameters) =>
    ShowPriceIndexConnectTooltipUrl;
